import { createTheme } from '@material-ui/core/styles';

import styles from './theme.scss';

const overrides = {
  MuiButton: { root: { outline: 'none !important' } },
  MuiIconButton: { root: { outline: 'none !important', padding: 8 } },
  MuiTab: { root: { outline: 'none !important' } },
  MuiChip: { root: { margin: 2 } },
  MuiDialogTitle: { root: { padding: 20, userSelect: 'none' } },
  MuiDialogContent: { root: { padding: 20 } },
  MuiDialogActions: { root: { padding: 20 } },
  MuiDialogContentText: { root: { userSelect: 'none' } },
  MuiTypography: { root: { userSelect: 'none' } },
};

const props = {
  MuiButton: { size: 'small' },
  MuiPaper: { elevation: 0 },
  MuiTabs: { indicatorColor: 'primary', textColor: 'primary' },
  MuiSwitch: { color: 'primary' },
};

export default createTheme({
  name: 'default',
  palette: {
    primary: {
      main: styles.color,
      light: styles.colorLight,
      dark: styles.colorDark,
      contrastText: styles.colorContrastText,
    },
    secondary: {
      main: styles.colorSecondary,
      light: styles.colorSecondaryLight,
      dark: styles.colorSecondaryDark,
    },
  },
  overrides,
  props,
});

export const host = createTheme({
  name: 'host',
  palette: {
    primary: {
      main: styles.hostColor,
      light: styles.hostColorLight,
      dark: styles.hostColorDark,
      contrastText: styles.hostColorContrastText,
    },
    secondary: {
      main: styles.hostColorSecondary,
    },
    iconTextExtras: {
      '&:hover': {
        color: '#ff8300 !important',
      },
    },
  },
  overrides,
  props,
});
